import React from 'react'
import audio from '../../../assets/img/audio.png';
import abc from '../../../assets/img/abc.png';
import stream from '../../../assets/img/streamStart.png';
import play from '../../../img/ic_play.png'
import starET from "../../../assets/img/starET.png"
import { BubbleIcon, CommentIcon, RecycleIcon, ShareIcon, ToshareIcon } from '../../../assets/icons';
import Options from '../../../utils/components/Options/Options';
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';

const renderPost = (data, isHover, options, style, userShared) => {
    var viewData

    // data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin

    const user = data.userId ? {
        name: data.userId.name.split(" ")[0],
        lastname: data.userId.lastname.split(" ")[0],
        picture: data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin
    } : data.franchiseID ? {
        name: data.franchiseID.socialReason,
        lastname: "",
        picture: data.franchiseID && data.franchiseID.picture && data.franchiseID.picture.url && data.franchiseID.picture.url.origin
    } :
        data.representativeID ? {
            name: data.representativeID.userID.name.split(" ")[0],
            lastname: data.representativeID.userID.lastname.split(" ")[0],
            picture: data.representativeID.userID && data.representativeID.userID.picture && data.representativeID.userID.picture.url && data.representativeID.userID.picture.url.origin
        } : data.franchiseId ? {
            name: data.franchiseId.socialReason,
            lastname: "",
            picture: data.franchiseId && data.franchiseId.picture && data.franchiseId.picture.url && data.franchiseId.picture.url.origin
        } : data.representativeId ? {
            name: data.representativeId.name.split(" ")[0],

            picture: data.representativeId && data.representativeId.picture && data.representativeId.picture.url && data.representativeId.picture.url.origin
        } : data.warehouseId ? {
            name: data.warehouseId.profileId.name.split(" ")[0],
            lastname: data.warehouseId.profileId.lastname.split(" ")[0],

            picture: data.warehouseId.profileId && data.warehouseId.profileId.picture && data.warehouseId.profileId.picture.url && data.warehouseId.profileId.picture.url.origin
        } : {
            name: "",
            lastname: ""
        }

    const w = style?.gridColumn?.trim().replace(/\s+/g, '_')
    const shared = style?.share === true ? true : false
    if (data && data.multimedia && data.multimedia.type) {

        if (data.multimedia?.type.includes('image'))
            viewData =
                <div className={`img-post-masory-card`}>
                    {
                        data.activePoints && <img className='post-masory-card-star' height={20} src={starET} />
                    }
                    {isHover && <Hover options={options} data={data} user={user} w={w} userShared={userShared} />}
                    <img
                        onError={(e) => {
                            e.target.src = (data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin) + "#"
                        }}

                        className='img-post-masory-card' src={data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin} alt="" />
                </div>

        if (data.multimedia?.type.includes('video'))
            viewData =
                <div className="img-post-masory-card">
                    {/* <video preload="none" autoPlay={false} className="video-post-view" controls poster={data.multimedia.url.thumbnail}>
                        <source src={data.multimedia.url ? data.multimedia.url.medium : data.multimedia.url.origin}></source>
                    </video> */}
                    {
                        data.activePoints && <img className='post-masory-card-star' height={20} src={starET} />
                    }
                    {isHover && <Hover options={options} data={data} user={user} w={w} userShared={userShared} />}
                    <div className="content-icon-play-video">
                        <img alt="img" className="img-video-post" src={play}></img>
                    </div>
                    <img alt="img"

                        className="img-post-masory-card" src={data.multimedia.url.thumbnail}></img>
                </div>
        if (data.multimedia?.type.includes('video/hls'))
            viewData =
                <div className="img-post-masory-card">
                    {/* <video preload="none" autoPlay={false} className="video-post-view" controls poster={data.multimedia.url.thumbnail}>
                 <source src={data.multimedia.url ? data.multimedia.url.medium : data.multimedia.url.origin}></source>
             </video> */}
                    {
                        data.activePoints && <img className='post-masory-card-star' height={20} src={starET} />
                    }
                    {isHover && <Hover options={options} data={data} user={user} userShared={userShared} w={w} />}
                    <div className="content-icon-play-video">
                        {data.multimedia.url.thumbnail && <img alt="img" className="img-video-post" src={play}></img>}

                    </div>
                    {
                        data.multimedia.url.thumbnail ? (
                            <img alt="img"
                            onError={(e) => {
                                e.target.src = (stream)
                            }}
                            
                            className="text-img-post-masory-card" src={data.multimedia.url.thumbnail}></img>
                        ) :
                            <img alt="img" className="text-img-post-masory-card" src={stream}></img>
                    }

                </div>
        if (data.multimedia.type.includes('audio'))
            viewData =
                <div className='img-post-masory-card'>
                    {
                        data.activePoints && <img className='post-masory-card-star' height={20} src={starET} />
                    }
                    {isHover && <Hover options={options} data={data} user={user} w={w} userShared={userShared} />}
                    <img className='audio-post-masory-card' src={audio} alt="" />
                </div>

        return (
            viewData
        )
    } else
        return (
            <div className='img-post-masory-card'>
                {
                    data.activePoints && <img className='post-masory-card-star' height={20} src={starET} />
                }
                {isHover && <Hover options={options} data={data} user={user} w={w} userShared={userShared} />}
                <img className='text-img-post-masory-card' src={abc} alt="" />
            </div>
        )
}
const renderSharedPost = (dataShared, data, isHover, options, style) => {
    var viewData
    style = { ...style, share: true }
    // data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin

    const user = data.userId ? {
        name: data.userId.name.split(" ")[0],
        lastname: data.userId.lastname.split(" ")[0],
        picture: data.userId && data.userId.picture && data.userId.picture.url && data.userId.picture.url.origin
    } :
        data.franchiseID ? {
            name: data.franchiseID.socialReason,
            lastname: "",
            picture: data.franchiseID && data.franchiseID.picture && data.franchiseID.picture.url && data.franchiseID.picture.url.origin
        } :
            data.representativeID ? {
                name: data.representativeID.userID.name.split(" ")[0],
                lastname: data.representativeID.userID.lastname.split(" ")[0],
                picture: data.representativeID.userID && data.representativeID.userID.picture && data.representativeID.userID.picture.url && data.representativeID.userID.picture.url.origin
            } : {
                name: "",
                lastname: ""
            }

    const w = style?.gridColumn?.trim().replace(/\s+/g, '_')
    return renderPost(dataShared, isHover, options, style, user)

}
const renderCampaing = (data, style, isHover) => {
    var viewData


    const w = style?.gridColumn?.trim().replace(/\s+/g, '_')

    if (data && data.multimedia && data.multimedia.type) {

        if (data.multimedia?.type.includes('image'))
            viewData =
                <div className={`img-post-masory-card`}>
                    {isHover && <HoverCampaing data={data} w />}
                    <img
                        onError={(e) => {
                            e.target.src = (data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin) + "#"
                        }}

                        className='img-post-masory-card' src={data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin} alt="" />
                </div>

        if (data.multimedia?.type.includes('video'))
            viewData =
                <div className="img-post-masory-card">

                    <div className="content-icon-play-video">
                        <img alt="img" className="img-video-post" src={play}></img>
                    </div>
                    <img alt="img"

                        className="img-post-masory-card" src={data.multimedia.url.thumbnail}></img>
                </div>
        if (data.multimedia?.type.includes('audio'))
            viewData =
                <div className='img-post-masory-card'>

                    <img className='img-post-masory-card' src={audio} alt="" />
                </div>

        return (
            viewData
        )
    } else
        return (
            <div className='img-post-masory-card'>
                {isHover && <HoverCampaing data={data} w />}
                <img className='text-img-post-masory-card' src={abc} alt="" />
            </div>)
}

const Hover = ({ options, data, user, w, userShared }) => {
    //(data.multimedia && !data.multimedia.type.includes("video/hls"))
    return (
        <div className={`post-masory-card-hover ${data.activePoints ? 'post-masory-card-hover-camp' : ''}`}>
            <div>
                <ImageNameDescription
                shouldEllipsis
                    type={`ind-text-post-masory-card ${w ? w : 'span_0'}`}
                    srcImage={userShared ? userShared.picture : user.picture}
                    firstName={userShared ? userShared.name : user.name}
                    secondName={userShared ? userShared.lastname : user.lastname}
                    typeOneText="purple"
                    description={userShared ? (
                        <div className='column'>
                            <div className='post-masory-share-icon'>
                                <ShareIcon
                                    height={15}
                                />
                            </div>
                            {user?.name} {user?.lastname}
                        </div>
                    ) : new Date(data.publicactionDate).toLocaleDateString()}

                />
                {
                    !data.multimedia && (
                        <div className='text-post-masory-card-contend'>
                            {data.description && data.description.substr(0, 100)} {data.description.length > 100 ? '...' : ''}
                        </div>

                    )
                }

            </div>

            <div className='post-masory-card-hover-icons-bar'>


                <div className='post-masory-card-hover-icons'>
                    <BubbleIcon height={"20px"} />{" "}
                    {data?.reactions?.bubbleLikes}
                </div>
                <div className='post-masory-card-hover-icons'>
                    <RecycleIcon height={"20px"} />{" "}
                    {data?.reactions?.recyclingLikes}
                </div>
                <div className='post-masory-card-hover-icons'>
                    <CommentIcon height={"20px"} />{" "}
                    {data?.comments}
                </div>
                <div className='post-masory-card-hover-icons'>
                    <ToshareIcon height={"20px"} />{" "}
                    {data?.shareds}
                </div>

            </div>
        </div>
    )
}
const HoverCampaing = ({ data }) => {
    return (
        <div className={`post-masory-card-hover post-masory-card-hover-camp`}>
            {
                true && (
                    <div className='text-post-masory-card-contend'>
                        {data.description}

                    </div>
                )
            }
            


        </div>
    )
}
export { renderPost, renderSharedPost, renderCampaing }